export const legalHrDocumentsArticle = {
  title: 'Legal & HR Document Hub: Generating Documents',
  slug: 'legal-hr-documents',
  content: `Legal & HR Document Hub: Generating Documents

Generate compliant documents with the Legal & HR tools.

1) Select a generator
- Open /legal-hr and choose the tool you need.

2) Complete the form
- Provide business details and jurisdiction where required.
- Review inputs before generating a document.

3) Generate and review
- Generate the document and review clauses.
- Export or copy content after review.

4) Keep compliance in mind
- Use the disclaimer guidance and confirm with legal counsel when needed.
`,
};
